import { ChartConfiguration } from 'chart.js';

/** Espacement autour du tracé (légende en bas). */
export const dashboardChartLayout = { padding: { bottom: 6, top: 4 } };

/** Pastille pleine = couleur de la série (lisible, sans cadre bicolore). */
export const dashboardLineLegendLabels = {
  usePointStyle: true,
  pointStyle: 'circle' as const,
  boxWidth: 10,
  boxHeight: 10,
  padding: 12,
  color: '#5e5873',
  font: { size: 12, weight: '500' as const },
};

export const dashboardBarLegendLabels = {
  usePointStyle: true,
  pointStyle: 'rectRounded' as const,
  boxWidth: 12,
  boxHeight: 12,
  padding: 16,
  color: '#5e5873',
  font: { size: 12, weight: '500' as const },
};

export function dashboardLineLegendPlugin(): NonNullable<
  ChartConfiguration<'line'>['options']
>['plugins'] {
  return {
    legend: {
      display: true,
      position: 'bottom',
      align: 'center',
      labels: { ...dashboardLineLegendLabels },
    },
  };
}

export function dashboardBarLegendPlugin(): NonNullable<
  ChartConfiguration<'bar'>['options']
>['plugins'] {
  return {
    legend: {
      display: true,
      position: 'bottom',
      align: 'center',
      labels: { ...dashboardBarLegendLabels },
    },
  };
}

/** Courbe : couleurs inchangées ; `backgroundColor` sert à la pastille légende. */
export function dashboardLineDataset(
  label: string,
  data: number[],
  color: string
): NonNullable<ChartConfiguration<'line'>['data']['datasets']>[number] {
  return {
    label,
    data,
    borderColor: color,
    backgroundColor: color,
    borderWidth: 2,
    tension: 0.35,
    pointRadius: 2,
    pointBackgroundColor: color,
    pointBorderColor: color,
    pointHoverRadius: 5,
    pointHitRadius: 8,
    fill: false,
  };
}
